import React, { useEffect } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconExpandLess from '@mui/icons-material/ExpandLess';
import IconExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MENU_STORE_TEXT } from '../../constants/DashboardConstants';
import { selectedStoreSelectorSaga } from '../../redux/saga/storePageSelectors';

const AppMenuItem = (props) => {

	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { name, Icon, items = [], link, classnameprops, navIndex, selectedNavIndex, setSelectedNavIndex, logoutHandle} = props;
	const isExpandable = items && items.length > 0;
	const [open, setOpen] = React.useState(false);
	const selectedStoreSelector = useSelector(selectedStoreSelectorSaga);
	
	// Open the parent if any of its children are selected
	useEffect(() => {  
		const isChildSelected = items.some(i => i.navIndex === selectedNavIndex);
		if (isChildSelected) {
		setOpen(true);
		}
	}, [selectedNavIndex, items]);

	function handleClick(name) {
		setOpen(!open);
		
		if (link) {
		setSelectedNavIndex(navIndex);
		if (name != 'Log Out') {
			if (name === MENU_STORE_TEXT) {
			if (selectedStoreSelector?.storeId && selectedStoreSelector?.storeUUID) {
				let childLink = `/dashboard/stores/singlestoreview/${selectedStoreSelector.storeId}`;
				navigate(childLink);
			} else {
				navigate(link);
			}
			
			} else {
				navigate(link);
			}
		} else {
			logoutHandle();
		}
		}
	}

	const MenuItemRoot = (
		<ListItemButton
		selected={navIndex === selectedNavIndex || items.some(i => i.navIndex === selectedNavIndex)}
		onClick={() => handleClick(name)}
		className='menu-items-list'
		data-testid='app-menu-item-id'
		>
		{/* Display an icon if any */}
		{!!Icon && (
			<ListItemIcon>
			<img src={Icon} />
			</ListItemIcon>
		)}
		<ListItemText primary={name} inset={!Icon} primaryTypographyProps={{ className: 'brand--box__label' }} />
		{/* Display the expand menu if the item has children */}
		{isExpandable && !open && <IconExpandMore />}
		{isExpandable && open && <IconExpandLess />}
		</ListItemButton>
	);

	const MenuItemChildren = isExpandable ? (
		<Collapse in={open} timeout='auto' unmountOnExit>
		<Divider />
		<List className='child-nav' component='div' disablePadding>
			{items.map((item, index) => (
			<AppMenuItem {...item} key={index} setSelectedNavIndex={(item) => setSelectedNavIndex(item)} selectedNavIndex={selectedNavIndex} />
			))}
		</List>
		</Collapse>
	) : null;

	return (
		<>
		{MenuItemRoot}
		{MenuItemChildren}
		</>
	);
};

export default AppMenuItem;
